import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../AxiosConfig';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';

const RegisterUser = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    user_email: '',
    phone: '',
    organization: '',
    role_in_org:'',
  });
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    try {
      await axios.post("/api/auth/register", formData);
      navigate('/'); 
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col xs={12} md={8} lg={6}>
          <Card className="shadow-lg p-4 rounded">
            <Card.Body>
              <h2 className="text-center mb-4">Register</h2>
              <p>
                You will recieve an email once your account has been approved which will allow you to set a password. 
                Please contact Alex if you have any questons.
              </p>
              {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
              <Form>
                <Form.Group controlId="formFirstName" className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control type="text"
                                placeholder="Enter your first name"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                required />
                </Form.Group>
                <Form.Group controlId="formLastName" className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control type="text"
                                placeholder="Enter your last name"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                required />
                </Form.Group>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email"
                                placeholder="Enter your email"
                                name="user_email"
                                value={formData.user_email}
                                onChange={handleChange}
                                required />
                </Form.Group>
                <Form.Group controlId="formPhone" className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control type="text"
                                placeholder="Enter your phone number"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required />
                </Form.Group>
                <Form.Group controlId="formOrganization" className="mb-3">
                  <Form.Label>Organization</Form.Label>
                  <Form.Control type="text"
                                placeholder="Enter the Organization you represent"
                                name="organization"
                                value={formData.organization}
                                onChange={handleChange}
                                required />
                </Form.Group>
                <Form.Group controlId="formRole" className="mb-3">
                  <Form.Label>Role in Organization</Form.Label>
                  <Form.Control type="text"
                                placeholder="What is your role in that organization"
                                name="role_in_org"
                                value={formData.role_in_org}
                                onChange={handleChange}
                                required />
                </Form.Group>
                <Button variant="primary" onClick={handleRegister} className="w-100">
                  Register
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RegisterUser;
